import { createIcon } from '@chakra-ui/react';

export const MbeEsFlag = createIcon({
  displayName: 'MbeEsFlag',
  viewBox: '0 0 64 64',
  path: (
    <g fill="none" fillRule="evenodd">
      <g transform="translate(4 4)">
        <mask fill="#fff" id="5cs2zig1sb">
          <use xlinkHref="#gru2icjqfa" />
        </mask>
        <path
          d="M28 1.412C13.34 1.412 1.412 13.339 1.412 28c0 14.66 11.927 26.588 26.588 26.588 14.66 0 26.588-11.927 26.588-26.588C54.588 13.34 42.661 1.412 28 1.412M28 56C12.56 56 0 43.44 0 28 0 12.56 12.56 0 28 0s28 12.56 28 28c0 15.439-12.56 28-28 28"
          fill="#E2001A"
          mask="url(#5cs2zig1sb)"
        />
      </g>
      <path
        d="M19.479 32c0 1.532.275 2.999.778 4.355L32 37.445l11.742-1.09c.504-1.356.78-2.823.78-4.355 0-1.532-.276-2.999-.78-4.355L32 26.555l-11.743 1.09A12.494 12.494 0 0 0 19.48 32"
        fill="#FD0"
      />
      <path
        d="M43.743 27.645c-1.77-4.768-6.36-8.166-11.743-8.166-5.384 0-9.973 3.398-11.742 8.166h23.485zM20.257 36.355c1.77 4.768 6.36 8.166 11.743 8.166 5.384 0 9.973-3.398 11.742-8.166H20.257z"
        fill="#E2001A"
      />
    </g>
  ),
});
